var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _path9, _rect3, _path10, _path11, _rect4, _rect5, _path12, _path13, _path14, _rect6, _rect7, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHBlogotipo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isologotipo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 175,
    height: 64.49,
    viewBox: "0 0 175 64.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83335",
    "data-name": "Trazado 83335",
    d: "M123.12,17.149a17.136,17.136,0,0,0-1.013-5.83h-10.3V1.02A17,17,0,0,0,105.979,0a17.178,17.178,0,0,0-5.83,1.028V11.318H89.85a16.967,16.967,0,0,0-1.02,5.83,17.17,17.17,0,0,0,1.028,5.83h10.254V33.263a17.273,17.273,0,0,0,11.661,0V23.008h10.283A17,17,0,0,0,123.12,17.149Z",
    transform: "translate(-18.78 0.009)",
    fill: "#cf3f43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83336",
    "data-name": "Trazado 83336",
    d: "M157.832,19.769a9.292,9.292,0,0,0-5.59-2.879,10.036,10.036,0,0,0,5.32-2.915,8.09,8.09,0,0,0,1.771-5.488q0-4.526-3.374-6.5A16.529,16.529,0,0,0,147.519,0H125.706a19.729,19.729,0,0,1-.146,34.363h20.283q6.647,0,10.386-1.844t3.746-7.7a7.361,7.361,0,0,0-2.143-5.043ZM138.314,6.5h3.6a6.093,6.093,0,0,1,3.236.78,2.762,2.762,0,0,1,1.283,2.558,2.66,2.66,0,0,1-1.356,2.544,7.157,7.157,0,0,1-3.469.729h-3.294Zm7.011,19.933a7.018,7.018,0,0,1-3.571.838h-3.44v-7.04h3.542a7.383,7.383,0,0,1,3.593.729,2.854,2.854,0,0,1,1.326,2.755,2.871,2.871,0,0,1-1.45,2.718Z",
    transform: "translate(-26.537 0.013)",
    fill: "#224a8d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83337",
    "data-name": "Trazado 83337",
    d: "M86.371,34.371A19.729,19.729,0,0,1,86.254,0H74V11.872H65.184V0H52V34.371H65.191V22.017H74V34.371Z",
    transform: "translate(-10.991 0.009)",
    fill: "#224a8d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83338",
    "data-name": "Trazado 83338",
    d: "M0,58.19H2.8v5.634H8.4V58.19h2.791V72.132H8.4V66.025H2.8v6.107H0Z",
    transform: "translate(0 -11.84)",
    fill: "#224a8d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83339",
    "data-name": "Trazado 83339",
    d: "M23.715,62.879a5.524,5.524,0,0,1,3.936,9.263,5.167,5.167,0,0,1-3.936,1.523,5.2,5.2,0,0,1-3.928-1.509,5.415,5.415,0,0,1,3.928-9.278m0,8.709a2.128,2.128,0,0,0,2-1.02,4.956,4.956,0,0,0,.6-2.544,3.542,3.542,0,0,0-.671-2.186,2.281,2.281,0,0,0-1.931-.889,2.252,2.252,0,0,0-1.909.933,3.557,3.557,0,0,0-.663,2.186,5.036,5.036,0,0,0,.583,2.544,2.114,2.114,0,0,0,1.99,1.02",
    transform: "translate(-4.926 -13.111)",
    fill: "#224a8d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83340",
    "data-name": "Trazado 83340",
    d: "M41.735,65.277a8.747,8.747,0,0,0-1.181-.335,6.138,6.138,0,0,0-1.2-.109,2.223,2.223,0,0,0-1.108.27.94.94,0,0,0-.474.875c0,.415.5.78,1.458,1.108a10.247,10.247,0,0,1,2.31,1.064,2.427,2.427,0,0,1,.845,2.186,2.842,2.842,0,0,1-1.246,2.529,5.386,5.386,0,0,1-3.068.838,10.331,10.331,0,0,1-1.458-.109,12.973,12.973,0,0,1-1.56-.328l.16-2.186a5.633,5.633,0,0,0,1.3.525,5.1,5.1,0,0,0,1.341.175,2.566,2.566,0,0,0,1.217-.284,1.013,1.013,0,0,0,.539-.977c0-.532-.773-1.049-2.325-1.552a2.876,2.876,0,0,1-2.332-2.813A2.733,2.733,0,0,1,36.13,63.7a4.861,4.861,0,0,1,2.864-.816,9.015,9.015,0,0,1,1.4.087c.357.058.867.153,1.523.292Z",
    transform: "translate(-7.746 -13.111)",
    fill: "#224a8d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83341",
    "data-name": "Trazado 83341",
    d: "M48.37,63.106h2.558v1.458a3.644,3.644,0,0,1,1.3-1.254,3.913,3.913,0,0,1,1.939-.445,3.71,3.71,0,0,1,3.265,1.494,6.559,6.559,0,0,1,1.049,3.855,6.683,6.683,0,0,1-1.057,3.877,3.746,3.746,0,0,1-3.316,1.538,4.1,4.1,0,0,1-1.633-.292,3.768,3.768,0,0,1-1.385-1.115L51.016,77.6H48.37Zm2.675,5.1a4.664,4.664,0,0,0,.568,2.332,1.909,1.909,0,0,0,1.8,1.006,1.8,1.8,0,0,0,1.727-1.02,4.818,4.818,0,0,0,.547-2.318,4.89,4.89,0,0,0-.517-2.3,1.786,1.786,0,0,0-1.713-.977,1.982,1.982,0,0,0-1.8,1.006,4.3,4.3,0,0,0-.641,2.281",
    transform: "translate(-10.679 -13.105)",
    fill: "#224a8d"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_147749",
    "data-name": "Rect\\xE1ngulo 147749",
    width: 2.675,
    height: 2.558,
    transform: "translate(50.506 44.951)",
    fill: "#224a8d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_147750",
    "data-name": "Rect\\xE1ngulo 147750",
    width: 2.675,
    height: 10.291,
    transform: "translate(50.506 50.001)",
    fill: "#224a8d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83342",
    "data-name": "Trazado 83342",
    d: "M73.792,64.073H71.81v-1.96h1.982V60.057l2.675-.867v2.915h2.376v1.96H76.467v4.81a2.449,2.449,0,0,0,.27,1.246,1.057,1.057,0,0,0,.991.459,2.186,2.186,0,0,0,1.217-.3l.08,2.135a7.215,7.215,0,0,1-1.975.24,3.192,3.192,0,0,1-2.412-.889,3.411,3.411,0,0,1-.845-2.456Z",
    transform: "translate(-15.921 -12.111)",
    fill: "#224a8d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83343",
    "data-name": "Trazado 83343",
    d: "M84.311,63.652a8.469,8.469,0,0,1,3.571-.773,4.738,4.738,0,0,1,3.4,1.013,4.518,4.518,0,0,1,1.042,3.323v3.892l.16,2.3H90.12a4.832,4.832,0,0,1-.095-.787c0-.262,0-.51,0-.729a3.338,3.338,0,0,1-1.392,1.283,3.907,3.907,0,0,1-1.851.474,3.972,3.972,0,0,1-2.522-.824,2.675,2.675,0,0,1-1.071-2.245,3.272,3.272,0,0,1,.466-1.822,3.046,3.046,0,0,1,1.224-1.093,5.416,5.416,0,0,1,1.654-.5,14.268,14.268,0,0,1,1.873-.124h1.458a2.267,2.267,0,0,0-.547-1.713,2.573,2.573,0,0,0-1.771-.51A4.789,4.789,0,0,0,85.9,65.1a6.02,6.02,0,0,0-1.531.831Zm3.112,8.061a2.318,2.318,0,0,0,1.071-.241,2.23,2.23,0,0,0,.787-.663,2.6,2.6,0,0,0,.452-.962,5.1,5.1,0,0,0,.124-1.188H88.721a5.313,5.313,0,0,0-2.114.364,1.392,1.392,0,0,0-.86,1.458,1.086,1.086,0,0,0,.459.955,2.187,2.187,0,0,0,1.217.277",
    transform: "translate(-18.388 -13.112)",
    fill: "#224a8d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_147751",
    "data-name": "Rect\\xE1ngulo 147751",
    width: 2.675,
    height: 13.993,
    transform: "translate(76.998 46.306)",
    fill: "#224a8d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83344",
    "data-name": "Trazado 83344",
    d: "M114.6,58.189h4.876a6.3,6.3,0,0,1,3.148.765,3.462,3.462,0,0,1,.619,4.868,3.425,3.425,0,0,1-2.019,1.057,3.768,3.768,0,0,1,2.318,1.042,2.959,2.959,0,0,1,.875,2.186,3.431,3.431,0,0,1-1.509,3.17,6.814,6.814,0,0,1-3.4.853H114.6Zm2.8,5.634h1.137a4.373,4.373,0,0,0,1.88-.357,1.356,1.356,0,0,0,.729-1.341,1.378,1.378,0,0,0-.729-1.407,4.847,4.847,0,0,0-1.975-.335h-1.079Zm0,6.115h1.319a4.461,4.461,0,0,0,2.033-.423A1.538,1.538,0,0,0,121.589,68a1.72,1.72,0,0,0-.794-1.662,4.308,4.308,0,0,0-2.077-.437H117.4Z",
    transform: "translate(-25.313 -11.84)",
    fill: "#224a8d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83345",
    "data-name": "Trazado 83345",
    d: "M131,63.113h2.376v2.339a3.4,3.4,0,0,1,.955-1.72,2.544,2.544,0,0,1,1.9-.853h.394a2.119,2.119,0,0,1,.43.073v2.7a1.407,1.407,0,0,0-.488-.16,3.716,3.716,0,0,0-.729-.066,1.764,1.764,0,0,0-1.633.933,6.93,6.93,0,0,0-.547,3.265V73.4H131Z",
    transform: "translate(-29.092 -13.112)",
    fill: "#224a8d"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_147752",
    "data-name": "Rect\\xE1ngulo 147752",
    width: 2.675,
    height: 2.558,
    transform: "translate(110.25 44.951)",
    fill: "#224a8d"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_147753",
    "data-name": "Rect\\xE1ngulo 147753",
    width: 2.675,
    height: 10.291,
    transform: "translate(110.25 50.001)",
    fill: "#224a8d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83346",
    "data-name": "Trazado 83346",
    d: "M150.135,64.073H148.16v-1.96h1.975V60.057l2.675-.867v2.915h2.383v1.96H152.81v4.81a2.448,2.448,0,0,0,.277,1.246,1.035,1.035,0,0,0,.984.459,2.186,2.186,0,0,0,1.217-.3l.08,2.135a7.177,7.177,0,0,1-1.975.24,3.163,3.163,0,0,1-2.405-.889,3.411,3.411,0,0,1-.853-2.456Z",
    transform: "translate(-32.849 -12.111)",
    fill: "#224a8d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83347",
    "data-name": "Trazado 83347",
    d: "M160.652,63.652a8.5,8.5,0,0,1,3.593-.773,4.743,4.743,0,0,1,3.4,1.013,4.506,4.506,0,0,1,1.035,3.323v3.892l.16,2.3h-2.354a5.828,5.828,0,0,1-.1-.787c0-.262,0-.51,0-.729a3.323,3.323,0,0,1-1.407,1.283,3.929,3.929,0,0,1-1.851.474,4.009,4.009,0,0,1-2.522-.8,2.675,2.675,0,0,1-1.071-2.245A3.273,3.273,0,0,1,160,68.776a3.076,3.076,0,0,1,1.217-1.093,5.459,5.459,0,0,1,1.662-.5,14.16,14.16,0,0,1,1.866-.124h1.458a2.237,2.237,0,0,0-.554-1.713,2.558,2.558,0,0,0-1.764-.51,4.759,4.759,0,0,0-1.647.292,6.019,6.019,0,0,0-1.53.831Zm3.134,8.017a2.318,2.318,0,0,0,1.071-.241,2.23,2.23,0,0,0,.787-.663,2.492,2.492,0,0,0,.452-.962,5.1,5.1,0,0,0,.131-1.188h-1.159a5.371,5.371,0,0,0-2.121.364,1.4,1.4,0,0,0-.86,1.458,1.086,1.086,0,0,0,.459.955,2.23,2.23,0,0,0,1.239.306",
    transform: "translate(-35.262 -13.112)",
    fill: "#224a8d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83348",
    "data-name": "Trazado 83348",
    d: "M175.4,63.11h2.536v1.4a3.914,3.914,0,0,1,1.458-1.246,4.512,4.512,0,0,1,1.939-.386,3.141,3.141,0,0,1,2.624,1.093,4.591,4.591,0,0,1,.875,2.915v6.494h-2.682V67.906a6.21,6.21,0,0,0-.3-2.186,1.341,1.341,0,0,0-1.458-.794,1.873,1.873,0,0,0-1.829,1.057,5.16,5.16,0,0,0-.532,2.361v5.029H175.4Z",
    transform: "translate(-38.764 -13.109)",
    fill: "#224a8d"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_147754",
    "data-name": "Rect\\xE1ngulo 147754",
    width: 2.675,
    height: 2.558,
    transform: "translate(150.496 44.951)",
    fill: "#224a8d"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_147755",
    "data-name": "Rect\\xE1ngulo 147755",
    width: 2.675,
    height: 10.291,
    transform: "translate(150.496 50.001)",
    fill: "#224a8d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83349",
    "data-name": "Trazado 83349",
    d: "M205.668,65.347a4.205,4.205,0,0,0-.809-.292,4.8,4.8,0,0,0-1.013-.087,2.427,2.427,0,0,0-1.975.926,3.644,3.644,0,0,0-.729,2.369,3.9,3.9,0,0,0,.729,2.434,2.427,2.427,0,0,0,2.063.9,4.01,4.01,0,0,0,1.049-.146A6.394,6.394,0,0,0,206,71.1l.117,2.237a6.091,6.091,0,0,1-1.2.262,12.568,12.568,0,0,1-1.458.08,4.73,4.73,0,0,1-3.753-1.5,5.743,5.743,0,0,1-1.319-3.943,5.612,5.612,0,0,1,1.268-3.8,4.584,4.584,0,0,1,3.644-1.509,9.125,9.125,0,0,1,2.6.335Z",
    transform: "translate(-43.132 -13.123)",
    fill: "#224a8d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83350",
    "data-name": "Trazado 83350",
    d: "M216.015,62.874a5.524,5.524,0,0,1,3.936,9.263,5.83,5.83,0,0,1-7.864,0,5.415,5.415,0,0,1,3.928-9.278m0,8.709a2.128,2.128,0,0,0,2-1.02,4.955,4.955,0,0,0,.6-2.544,3.542,3.542,0,0,0-.671-2.186,2.281,2.281,0,0,0-1.931-.889,2.252,2.252,0,0,0-1.909.947,3.557,3.557,0,0,0-.663,2.186,5.035,5.035,0,0,0,.583,2.544,2.113,2.113,0,0,0,1.99,1.02",
    transform: "translate(-46.409 -13.106)",
    fill: "#224a8d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83351",
    "data-name": "Trazado 83351",
    d: "M165.719,57.58l-1.509,2.646h1.662l2.478-2.646Z",
    transform: "translate(-36.563 -12.757)",
    fill: "#224a8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHBlogotipo);
export default __webpack_public_path__ + "static/media/HBlogotipo.4845f2163fbed766693e3bb4b46d76ed.svg";
export { ForwardRef as ReactComponent };